export enum InputGroupsType {
  Fertilizer = 'fertilizer',
  Pesticide = 'pesticide',
  Seed = 'seed',
  Farm = 'farm',
  Tool = 'tool',
  Machinery = 'machinery',
  Worker = 'worker',
  Lab = 'lab',
  Employee = 'employee',
}
export enum LaboratoryInputGroups {
  WaterAndSoil = 11, // آب و خاک
  Plant = 12,
  FertilizerPesticide = 13, // کود و سم
  Animal = 14, // دام
}
